module.exports = __webpack_public_path__ + "static/Nanopesos2-144dce3c5aa6f9c65e2b40c22ffa69a5.png";